
export function launchToast(title, icon, bgColor) {
  var x = document.getElementById("toast");
  var p = $("#toast p");
  var span = $("#toast span");
  var bg = $("#toast #img");
  x.className = "show";
  p.html(title);
  span.html(icon);
  bg.css({ "background-color": bgColor });
  setTimeout(function () {
    x.className = x.className.replace("show", "");
  }, 3000);
}

export function pushRecentSearches(title) {
    var recentSearches = localStorage.getItem("recent-searches") ? localStorage.getItem("recent-searches").split(",") : [];
    recentSearches.push(title);

    localStorage.setItem("recent-searches", recentSearches);
    if (recentSearches.length > 0) {

        //remove duplicate terms
        var recentSearchesUnique = recentSearches.filter(function (element, index, self) {
            return index === self.indexOf(element);
        });


        var index = 0;
        if (recentSearchesUnique != null) {

            var lengthOfRecentSearches = recentSearchesUnique.length;
            if (lengthOfRecentSearches > 5)
                index = lengthOfRecentSearches - 5;
            recentSearchesUnique = recentSearchesUnique.slice(index, recentSearchesUnique.length);
            localStorage.setItem("recent-searches", recentSearchesUnique);
        }

    }

    //commenting the rendering as this is to render in the profile control //removed from profile added to search box Task#12385
    //renderRecentSearch(title);

}

export function getRecentSearches() {
  if (localStorage.getItem("recent-searches") != null) {
    var recentSearches = localStorage.getItem("recent-searches").split(",");
    var index = 0;
    if (recentSearches != null) {
      while (index < recentSearches.length) {
        //renderRecentSearch(recentSearches[index]);
        index++;
      }
    }
  }
}

export function renderRecentSearch(searchItem) {
  var template = document.querySelector("#recent-serch-template");

  var clone = template.content.cloneNode(true);
  var title = clone.querySelectorAll("p");
  title[0].innerText = searchItem;

  var item = clone.querySelectorAll("li");

  item[0].onclick = function () {
    var baseUrl = window.location.origin;
      var searchURL = baseUrl + "/Search/?q=" + encodeURIComponent(searchItem);
    location.href = searchURL;
  };

  $($(".recent-searches").append(clone));
}

export function clearPageSearchText(control) {
    var parent = control.parents("#page-search-bar");
    var searchBox = parent.find("#search-text");
    searchBox.val("");
    $("#search-text").keyup();
}

export function ObfuscateApaMailTags(id, color) {
    //allow a global load, but preferably only process the emails from the specific component at a time to prevent this running multiple times on the same link
    var controls;
    if (id == null) {
        controls = $("apamail");
    } else {
        controls = $("#" + id).find("apamail");
    }

    var isPublicPage = false;
    if ($("#isPublicPage").length > 0) {
        if ($("#isPublicPage").val() == 'true') {
            isPublicPage = true;
        }
    }
    
    if (controls != null && isPublicPage) {
        controls.each(function (index) {
            var anchor = APA_Email_GenerateAnchor(this.getAttribute("name"), this.getAttribute("domain"), this.getAttribute("class"), color);
            $(this).html(anchor);
        });
    } else {
        //replace the placeholder with a normal link if it is not a public page
        controls.each(function (index) {
            var anchor = "<a href='mailto:" + this.getAttribute("name") + String.fromCharCode(64) + this.getAttribute("domain") +
                          "' class='" + this.getAttribute("class") + "' " + color + ">" + 
                                this.getAttribute("name") + String.fromCharCode(64) + this.getAttribute("domain") + 
                         "</a>";
            $(this).html(anchor);
        });
    }
}
function APA_Email_GenerateAnchor(name, domain, cssClasses, color) {
    // does not support dark mode toggle
    //if (color != null && color != "") {
    //    color = " style='color:" + color + "' ";
    //} else {
    //    color = "";
    //}

    if (cssClasses != null && cssClasses != "") {
        cssClasses = " class='" + cssClasses + "' ";
    } else {
        cssClasses = "";
    }
    
    var email = name + String.fromCharCode(64) + domain;
    var visibleText = APA_Email_GenerateVisibleText(name, domain);
    var html = "<a href=\"javascript:void(location.href=EntryPoint.Utils.APA_Email_ContactClick('" + APA_Email_Reverse(name) +
        "', '" + APA_Email_Reverse(domain) + "'))\" " + cssClasses + ">" + visibleText + "</a>";
    return html;
}

function APA_Email_GenerateVisibleText(name, domain) {
    var blankSpan = "<span style='display:none'>xyz</span>";
    return blankSpan.concat(
        name,
        blankSpan,
        String.fromCharCode(64),
        blankSpan,
        domain,
        blankSpan
    );
}

export function APA_Email_ContactClick(name, domain) {
    var a = "mai"; //seperate to prevent stuff from searching for the combined word
    a += "lto:";
    a += APA_Email_Reverse(name);
    a += String.fromCharCode(64);
    a += APA_Email_Reverse(domain);
    return a;
}

function APA_Email_Reverse(s) {
    return s.split("").reverse().join("");
}

export function closeEVAppPopup(control, showConfirm) {
    var wrapper = control.parents(".popup-app-wrapper");
    if (typeof wrapper != "undefined" && wrapper.length > 0) {
        if (showConfirm != null && showConfirm == true) {
            var result = confirm(
                "Are you sure you want to close? You will lose unsaved changes."
            );
            if (result != true) {
                return false;
            }
        }
        wrapper.remove();
    }
}

//NC-04052023 Need to refactor this in a better way.
var timer = null;
var istrue = false;
var start_time;
export function startPressTimer() {
    start_time = new Date();
}

export function endPressTimer(link, openNewTab) {
    var now = new Date();
    var timed = now - start_time;
    console.log(timed);
    if (timed > 500) {
        istrue = true;
        timer = setTimeout(function () {
            makeChange();
        }, 200);
    } else {
        if (!$("#Search-Engine .icons").hasClass("edit")) {
            if (openNewTab == "true") {
                window.open(link, "_blank");
            } else {
                window.location.href = link; //opens in the same tab
            }
        }
    }
}

function makeChange() {
    if (timer) {
        clearTimeout(timer);
    }
    if (istrue) {
        if ($("#Search-Engine .icons").hasClass("edit")) {
            // click off in body now controls this
            //$("#Search-Engine .icons").removeClass("edit");
            //$("#Search-Engine .icons span").addClass("d-none");
        } else {
            $("#Search-Engine .icons").addClass("edit");
            $("#Search-Engine .icons span").removeClass("d-none");
        }
    }
}

function revert() {
    istrue = false;
}